// Macal — popups de captura de lead (Ligação 0800 / WhatsApp).
// Tarefa A513-T33. Reaproveita o mecanismo Web-to-Lead direto da Zoho CRM
// já validado no WordPress (Opção A — client-side, sem backend/app novo).
//
// Contrato de eventos (window.dispatchEvent, CustomEvent):
//   whatsapp_popup_open    { popup: 'ligacao' | 'whatsapp' }
//   whatsapp_lead_submit   { popup, lead_source, has_door_hint }
//   whatsapp_route_selected{ popup: 'whatsapp', group: 'porta'|'site'|'geral', band, vendor }
//   whatsapp_redirect      { popup, destination: 'phone'|'vendor'|'site', target }
//   phone_click             { popup: 'ligacao' }
//   whatsapp_lead_error    { popup, reason }
//   (phone_click também traz `origin` quando vem de um link tel: da página)
//
// Nenhum dado pessoal (nome/e-mail/telefone/mensagem) é incluído em nenhum
// evento — apenas metadados de roteamento/canal, conforme briefing A513-T33.
//
// Cada CustomEvent acima também é encaminhado ao GA4 (gtag, ou dataLayer se
// gtag não existir), com nomes próprios para o GA4 (ver toGa4Event) e sem o
// destino/telefone. Não envia se o consentimento de analytics for negado.
//
// Links a[href^="tel:"] fora dos popups abrem o popup de Ligação em vez de
// discar direto (o formulário captura o lead e só então dispara o tel:).
//
// Regras de roteamento (atualizadas em 2026-09-23):
//   Porta (qualquer faixa)       -> Thais (Douglas saiu em 19/10/2026)
//   Não-porta, 0-10 m²           -> permanece no site (sem vendedor)
//   Não-porta, 10-50 m² e >50 m² -> sorteio entre Bruno, Ana Lívia e Matheus; acima de 50 m² inclui também Marcelo (06/10/2026; Felipe saiu em 06/10/2026)
// Thais atende SOMENTE portas (Douglas saiu em 19/10/2026).

(function () {
  'use strict';

  if (window.__macalLeadPopupLoaded) return;
  window.__macalLeadPopupLoaded = true;

  var ROUTER_VERSION = 'shopify-v2.9.1-zulu-20261019';
  // 2026-10-15: popup de Ligação desligado (CTM DNI). false = links tel: discam direto e o gatilho "phone" não abre popup.
  // Para reverter: true.
  var PHONE_POPUP_ENABLED = false;
  var PHONE_NUMBER = '08006068143';

  var VENDEDORES_GERAL = [
    { nome: 'Bruno', telefone: '5531983415122' },
    { nome: 'Ana Lívia', telefone: '5531994340777' },
    { nome: 'Matheus', telefone: '5531983494210' }
  ];

  // 06/10/2026: Marcelo Castro entra no sorteio SÓ na faixa acima de 50 m² (nome igual à opção "Marcelo" do campo Operador no Zoho).
  var VENDEDORES_ACIMA_50 = VENDEDORES_GERAL.concat([
    { nome: 'Marcelo', telefone: '5531994380416' }
  ]);

  // Portas: só a Thais. Douglas saiu em 19/10/2026 (tinha sido reincluído em 2026-09-23, substitui
  // a decisão de 2026-08-17). Thais deixou de atender a faixa 10-50 m².
  var VENDEDORES_PORTA = [
    { nome: 'Thais', telefone: '5531985428504' }
  ];

  // v2: cache separado por grupo (porta / geral), para um vendedor de um
  // grupo nunca ser reaproveitado no outro.
  var SESSION_SELLER_KEY = 'macal:whatsapp_pool_seller:v2';
  var SESSION_TTL_MS = 30 * 60 * 1000;
  // Mesma chave usada no WordPress (persistência de UTM entre páginas).
  // Se esse mecanismo ainda não existir na Shopify, o formulário funciona
  // normalmente só com os parâmetros da URL atual.
  var UTM_STORAGE_KEY = 'macal:utm';
  var UTM_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var SITE_ACK_KEY = 'macal:lead_site_ack';

  var TRACK_QUERY_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'oppref'
  ];

  function safeJsonParse(raw, fallback) {
    if (!raw) return fallback;
    try {
      return JSON.parse(raw);
    } catch (_e) {
      return fallback;
    }
  }

  function getQueryParams() {
    var params = new URLSearchParams(window.location.search || '');
    var obj = {};
    params.forEach(function (value, key) {
      obj[(key || '').toLowerCase()] = (value || '').toString().slice(0, 180);
    });
    return obj;
  }

  function getStoredUtm() {
    try {
      var stored = safeJsonParse(localStorage.getItem(UTM_STORAGE_KEY), {});
      if (stored && stored._ts && Date.now() - stored._ts > UTM_TTL_MS) {
        localStorage.removeItem(UTM_STORAGE_KEY);
        return {};
      }
      return stored || {};
    } catch (_e) {
      return {};
    }
  }

  // Respeita o consentimento de marketing quando a Customer Privacy API da
  // Shopify estiver carregada; sem a API (nenhum banner configurado), grava.
  function marketingStorageAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function') {
        return privacy.marketingAllowed() !== false;
      }
    } catch (_e) {
      /* fall through: treat as allowed */
    }
    return true;
  }

  // Grava gclid/UTM da URL atual em localStorage (validade de 90 dias) para
  // sobreviver à navegação entre páginas. Só sobrescreve quando a URL atual
  // traz algum parâmetro de rastreio (último clique), mantendo o conjunto
  // consistente; sem parâmetros na URL, preserva o que já estava guardado.
  var CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'oppref'];

  function hasClickId(obj) {
    return CLICK_ID_KEYS.some(function (key) {
      return Boolean(obj && obj[key]);
    });
  }

  // Correção 03/10/2026 (ZULU SCOUT): antes, qualquer visita com algum parâmetro
  // de rastreio substituía o objeto salvo inteiro, e um gclid anterior se perdia.
  // Agora: clique novo (gclid/gbraid/wbraid/fbclid/ttclid na URL) substitui tudo;
  // visita só com utm_* não apaga o identificador de clique já salvo; e os
  // parâmetros do feed gratuito (sag_organic/product_sync) não sobrescrevem uma
  // atribuição paga que já existe.
  function persistAttribution() {
    if (!marketingStorageAllowed()) return;
    var qp = getQueryParams();
    var found = {};
    var hasAny = false;
    TRACK_QUERY_KEYS.forEach(function (key) {
      if (qp[key]) {
        found[key] = qp[key];
        hasAny = true;
      }
    });
    if (!hasAny) return;

    var stored = getStoredUtm();
    var next;
    if (hasClickId(found)) {
      next = found;
    } else {
      var freeListing = found.utm_campaign === 'sag_organic' || found.utm_medium === 'product_sync';
      if (freeListing && hasClickId(stored)) return;
      var storedSource = (stored.utm_source || '').toLowerCase();
      var foundSource = (found.utm_source || '').toLowerCase();
      // 06/10/2026 (#5): visita só com utm de OUTRA origem (ex.: newsletter) não troca campanha/termo do clique.
      if (hasClickId(stored) && foundSource && foundSource !== storedSource) return;
      next = {};
      Object.keys(stored).forEach(function (key) {
        if (key !== '_ts') next[key] = stored[key];
      });
      Object.keys(found).forEach(function (key) {
        next[key] = found[key];
      });
    }
    next._ts = Date.now();
    try {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(next));
    } catch (_e) {
      /* localStorage unavailable: lead still uses the current URL params */
    }
  }

  // Único ponto a mudar se o Victor preferir outro nome que não conte como
  // conversão automática no GA4 (generate_lead é evento recomendado do GA4).
  var GA4_LEAD_EVENT = 'generate_lead';

  // Restringe o gtag('event') à propriedade GA4: sem send_to, o mesmo evento
  // iria também ao Google Ads, ao Merchant Center e ao DoubleClick.
  var GA4_MEASUREMENT_ID = 'G-GP67SN8R12';

  function toGa4Event(name, d) {
    switch (name) {
      case 'phone_click':
        return { name: 'phone_click', params: { origin: d.origin || 'botao_flutuante' } };
      case 'whatsapp_popup_open':
        return { name: 'lead_popup_open', params: { popup: d.popup } };
      case 'whatsapp_lead_submit':
        return {
          name: GA4_LEAD_EVENT,
          params: { method: d.popup, lead_source: d.lead_source, has_door_hint: String(!!d.has_door_hint) }
        };
      case 'whatsapp_redirect':
        return { name: 'lead_redirect', params: { popup: d.popup, destination: d.destination } };
      case 'whatsapp_lead_error':
        return { name: 'lead_error', params: { popup: d.popup, reason: d.reason } };
      case 'whatsapp_route_selected':
        return { name: 'lead_route_selected', params: { band: d.band, group: d.group, vendor: d.vendor } };
      default:
        return null;
    }
  }

  // Respeita o consentimento de analytics quando a Customer Privacy API da
  // Shopify estiver carregada; sem a API, envia (mesmo critério do gclid/UTM).
  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed() !== false;
      }
    } catch (_e) {
      /* fall through: treat as allowed */
    }
    return true;
  }

  function forwardToAnalytics(name, detail) {
    try {
      var mapped = toGa4Event(name, detail || {});
      if (!mapped || !analyticsAllowed()) return;
      if (typeof window.gtag === 'function') {
        var gtagParams = { send_to: GA4_MEASUREMENT_ID };
        Object.keys(mapped.params).forEach(function (key) {
          gtagParams[key] = mapped.params[key];
        });
        window.gtag('event', mapped.name, gtagParams);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var payload = { event: mapped.name };
        Object.keys(mapped.params).forEach(function (key) {
          payload[key] = mapped.params[key];
        });
        window.dataLayer.push(payload);
      }
    } catch (_e) {
      /* no-op: analytics must never block the lead flow */
    }
  }

  function dispatch(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (_e) {
      /* no-op: event dispatch must never block the lead flow */
    }
    forwardToAnalytics(name, detail); try { if (name === 'whatsapp_route_selected') { window.__macalOaiBand = (detail && detail.band) || ''; } if (name === 'whatsapp_lead_submit') { var faixaOai = window.__macalOaiBand || ''; window.__macalOaiBand = ''; var agoraOai = Date.now(), travaOai = null; try { travaOai = JSON.parse(localStorage.getItem('macal:oai_lead') || 'null'); } catch (_t) {} var recenteOai = !!(travaOai && travaOai.ts && (agoraOai - travaOai.ts) < 1800000); if ((faixaOai === '10-50' || faixaOai === '>50') && !recenteOai && typeof window.oaiq === 'function' && marketingStorageAllowed()) { var idOai = 'lead_' + agoraOai + '_' + Math.random().toString(36).slice(2, 8); try { localStorage.setItem('macal:oai_lead', JSON.stringify({ ts: agoraOai, id: idOai })); } catch (_s) {} window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: idOai }); } } } catch (_e) {}
  }

  function cryptoRandInt(max) {
    try {
      var arr = new Uint32Array(1);
      crypto.getRandomValues(arr);
      return arr[0] % max;
    } catch (_e) {
      return Math.floor(Math.random() * max);
    }
  }

  function pickRandom(list) {
    return list[cryptoRandInt(list.length)];
  }

  // Vendedor fixo por 30 min na sessão, com cache separado por grupo.
  function getOrCreateSessionSeller(list, group) {
    var key = SESSION_SELLER_KEY + ':' + group;
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var data = JSON.parse(raw);
        if (Date.now() - data.ts < SESSION_TTL_MS) {
          var found = list.filter(function (v) {
            return v.telefone === data.telefone;
          })[0];
          if (found) return found;
        }
      }
    } catch (_e) {
      /* fall through to a fresh pick */
    }

    var seller = pickRandom(list);
    try {
      sessionStorage.setItem(
        key,
        JSON.stringify({ telefone: seller.telefone, nome: seller.nome, ts: Date.now() })
      );
    } catch (_e) {
      /* sessionStorage unavailable: still returns a valid seller for this submit */
    }
    return seller;
  }

  function computeLeadSource() {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    if (qp.oppref) return 'ChatGPT Ads'; if (qp.gclid || qp.gbraid || qp.wbraid) return 'Google Ads';
    if (qp.fbclid) return 'Facebook';
    if (utm.oppref) return 'ChatGPT Ads'; if (utm.gclid || utm.gbraid || utm.wbraid) return 'Google Ads';
    if (utm.fbclid) return 'Facebook';
    return 'Orgânico';
  }

  // Zoho 2.0 (handoff 2026-09-30): zc_gad é exclusivo do Google Ads — não
  // misturar fbclid/ttclid aqui (bug herdado da 1.0, corrigido no
  // institucional e replicado aqui).
  // Correção 03/10/2026 (ZULU SCOUT): zc_gad leva SÓ o gclid. gbraid e wbraid
  // (cliques de iOS/web-para-app) têm campo próprio no formulário do Zoho
  // (LEADCF16 = gbraid, LEADCF1 = wbraid) e não podem cair no campo GCLID.
  function computeZcGad() {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    return qp.gclid || utm.gclid || '';
  }

  function computeGbraid() {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    return (qp.gbraid || utm.gbraid || '').toString().slice(0, 255);
  }

  function computeWbraid() {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    return (qp.wbraid || utm.wbraid || '').toString().slice(0, 255);
  }

  function computeCampanha() {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    return (qp.utm_campaign || utm.utm_campaign || '').toString().slice(0, 180);
  }

  function computePalavraChave() {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    return (qp.utm_term || utm.utm_term || '').toString().slice(0, 180);
  }

  function isDoorPage(hint) {
    var qp = getQueryParams();
    var utm = getStoredUtm();
    var override = (qp.rota || qp.route || utm.rota || utm.route || '').toString().toLowerCase();

    if (override === 'porta' || override === 'portas') return true;
    if (override === 'geral') return false;
    if (hint) return true;

    return /(^|\/)(collections\/|categoria\/)?portas?(\/|$)/i.test(window.location.pathname || '');
  }

  function normalizeBrDigits(value) {
    // 05/10/2026: tira zeros à esquerda e o 55 do país (número com mais de 11 dígitos) antes do +55.
    var d = (value || "").replace(/\D/g, "").replace(/^0+/, "");
    if (d.length > 11 && d.slice(0, 2) === "55") d = d.slice(2);
    return d.slice(0, 11);
  }

  function maskPhoneNumber(event) {
    var input = event.target;
    var digits = normalizeBrDigits(input.value);

    if (digits.length <= 2) {
      input.value = digits ? '(' + digits : '';
      return;
    }

    var ddd = digits.slice(0, 2);
    var rest = digits.slice(2);

    if (digits.length === 10) {
      input.value = '(' + ddd + ') ' + rest.slice(0, 4) + '-' + rest.slice(4);
    } else if (digits.length === 11) {
      input.value = '(' + ddd + ') ' + rest.slice(0, 1) + ' ' + rest.slice(1, 5) + '-' + rest.slice(5);
    } else {
      input.value = '(' + ddd + ') ' + rest;
    }
  }

  // 06/10/2026 (#4): telefone precisa de DDD + 8 dígitos (10 dígitos no mínimo); a mensagem aparece no próprio campo.
  function applyPhoneValidity(form) {
    var el = form.querySelector('[data-macal-phone-mask]');
    if (!el) return;
    var ok = normalizeBrDigits(el.value).length >= 10;
    el.setCustomValidity(ok ? '' : 'Informe um telefone com DDD, ex.: (31) 99999-9999');
  }

  function formatPhoneBeforeSubmit(form) {
    var mobile = form.querySelector('[data-macal-phone-mask]');
    // Correção 03/10/2026 (ZULU SCOUT): mesmo formato do site institucional
    // (+55 + só dígitos). Antes a Loja enviava só dígitos, e o CRM ficava com
    // dois formatos para o mesmo tipo de lead.
    if (mobile) {
      // A máscara limita a 11 dígitos (DDD + número); DDD 55 existe (RS), por
      // isso o prefixo é sempre acrescentado, igual ao site.
      var digits = normalizeBrDigits(mobile.value);
      mobile.value = digits ? '+55' + digits : '';
      // 05/10/2026: campo Celular (Mobile) do Zoho recebe o mesmo valor do Phone.
      var mobileZoho = form.querySelector('input[name="Mobile"]');
      if (mobileZoho) mobileZoho.value = mobile.value;
    }
  }

  function setStatus(form, message, tone) {
    var status = form.querySelector('[data-macal-lead-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    if (tone) {
      status.setAttribute('data-status-tone', tone);
    } else {
      status.removeAttribute('data-status-tone');
    }
  }

  function setSubmitting(form, submitting) {
    var button = form.querySelector('[data-macal-lead-submit]');
    if (!button) return;
    if (submitting) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('aria-disabled');
      button.removeAttribute('disabled');
    }
  }

  function preloadCommonFields(form, idSuffix) {
    // Migração Zoho 2.0 (2026-09-30): LEADCF25->LEADCF6 (anonymous_id),
    // LEADCF153->LEADCF27 (Campanha GADS), LEADCF156/novo->LEADCF38
    // (Palavra-chave Site / utm_term). Ver docs/architecture/migracao-leads-zoho-2.0.md.
    var leadCf6 = form.querySelector('#LEADCF6_' + idSuffix);
    if (leadCf6) leadCf6.value = window.fs_anon_id || '';

    var leadCf27 = form.querySelector('#LEADCF27_' + idSuffix);
    if (leadCf27) leadCf27.value = computeCampanha();

    var leadCf38 = form.querySelector('#LEADCF38_' + idSuffix);
    if (leadCf38) leadCf38.value = computePalavraChave();

    syncClickFields(form);
  }

  // Correção 03/10/2026 (ZULU SCOUT): o zcga.js grava a string "undefined" em
  // zc_gad quando não há gclid na URL nem cookie; essa string era tratada como
  // "já preenchido" e o gclid salvo nunca era usado. Aqui "undefined"/"null"
  // contam como vazio, e a função roda de novo no envio.
  function isEmptyClickValue(value) {
    var v = (value || '').toString().trim().toLowerCase();
    return v === '' || v === 'undefined' || v === 'null';
  }

  function syncClickFields(form) {
    var zcGad = form.querySelector('input[name="zc_gad"]');
    if (zcGad && isEmptyClickValue(zcGad.value)) zcGad.value = computeZcGad();
    // 06/10/2026 (#2): o campo GCLID do Zoho tem 150 caracteres; acima disso o lead inteiro é recusado.
    // Se passar do limite, envia vazio (o clique continua na URL Final).
    if (zcGad && (zcGad.value || '').length > 150) zcGad.value = '';

    var gbraidField = form.querySelector('input[name="LEADCF16"]');
    if (gbraidField) gbraidField.value = computeGbraid();
    var wbraidField = form.querySelector('input[name="LEADCF1"]');
    if (wbraidField) wbraidField.value = computeWbraid();

    var leadSource = form.querySelector('input[name="Lead Source"]');
    if (leadSource) leadSource.value = computeLeadSource();
  }

  // O campo URL Final do CRM tem 255 caracteres. Se a página atual não traz os
  // parâmetros de rastreio (2ª/3ª página da sessão), acrescenta os salvos, com
  // os utm_* antes do identificador de clique, e corta em 255.
  var URL_FINAL_MAX = 255;
  var URL_FINAL_ORDER = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'gbraid', 'wbraid', 'oppref'];

  function buildUrlFinal() {
    var base = window.location.href || '';
    try {
      var url = new URL(base);
      var utm = getStoredUtm();
      URL_FINAL_ORDER.forEach(function (key) {
        if (!url.searchParams.has(key) && utm[key]) url.searchParams.set(key, String(utm[key]).slice(0, 180));
      });
      // 2026-10-26: oppref vai para o inicio da URL Final para nao ser cortado no limite de 255. So age quando ha oppref; demais canais ficam iguais.
      var opp = url.searchParams.get('oppref'); if (opp) { var uc = url.searchParams.get('utm_content'); url.searchParams.delete('oppref'); url.searchParams.delete('utm_content'); var resto = url.searchParams.toString(); url.search = '?oppref=' + encodeURIComponent(opp) + (uc ? '&utm_content=' + encodeURIComponent(uc) : '') + (resto ? '&' + resto : ''); }
      base = url.toString();
    } catch (_e) {
      /* mantém a URL atual */
    }
    return base.slice(0, URL_FINAL_MAX);
  }

  function writeUrlFinal(form, idSuffix) {
    var leadCf4 = form.querySelector('#LEADCF4_' + idSuffix);
    if (leadCf4) leadCf4.value = buildUrlFinal();
  }

  // === Popup Ligação — destino fixo, sem roteamento de vendedor =========
  function initLigacaoForm(form) {
    var doorRoot = document.getElementById('macal-lead-popup-root');
    preloadCommonFields(form, 'Call');
    writeUrlFinal(form, 'Call');

    form.addEventListener('input', function (event) {
      if (event.target && event.target.hasAttribute('data-macal-phone-mask')) {
        maskPhoneNumber(event);
        event.target.setCustomValidity('');
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      // 06/10/2026 (#8): campo anti-robô preenchido = não é pessoa; não envia.
      var honeypot = form.querySelector('[name="aG9uZXlwb3Q"]');
      if (honeypot && (honeypot.value || '').trim()) return;
      if (form.__macalSubmitting) return;

      // O <form> tem novalidate (evita o navegador decidir sozinho o
      // momento/estilo do aviso), então a validação de required precisa ser
      // feita explicitamente aqui — sem isso, o submit segue mesmo com
      // campos obrigatórios vazios (bug real, 80 leads sem contato desde
      // 02/09/2026, ver handoff de 2026-09-22).
      applyPhoneValidity(form);
      if (typeof form.reportValidity === 'function' && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      form.__macalSubmitting = true;

      setSubmitting(form, true);
      setStatus(form, 'Enviando...', null);

      syncClickFields(form);
      writeUrlFinal(form, 'Call');
      formatPhoneBeforeSubmit(form);

      dispatch('whatsapp_lead_submit', {
        popup: 'ligacao',
        lead_source: form.querySelector('input[name="Lead Source"]').value,
        has_door_hint: doorRoot ? doorRoot.getAttribute('data-door-hint') === 'true' : false
      });

      var finalized = false;
      function finalize() {
        if (finalized) return;
        finalized = true;
        // O retorno HTTP real do Zoho é opaco a partir do formulário
        // Web-to-Lead (cross-origin, sem callback de sucesso/erro
        // confiável) — mesma limitação já aceita na implementação
        // WordPress. Como o form aponta para um iframe oculto, a navegação
        // do redirecionamento tel: é feita diretamente aqui, sem depender
        // do returnURL da Zoho (bug documentado no handoff).
        try {
          form.submit();
        } catch (_e) {
          dispatch('whatsapp_lead_error', { popup: 'ligacao', reason: 'form_submit_failed' });
        }

        dispatch('whatsapp_redirect', { popup: 'ligacao', destination: 'phone', target: 'tel:' + PHONE_NUMBER });

        window.setTimeout(function () {
          window.location.href = 'tel:' + PHONE_NUMBER;
        }, 400);
      }

      window.setTimeout(finalize, 400);
    });
  }

  // === Popup WhatsApp — roteamento por categoria/faixa de m² ============
  // Porta (qualquer faixa)       -> Thais
  // Não-porta, 0-10 m²           -> permanece no site
  // Não-porta, 10-50 m² e >50 m² -> vendedores gerais
  function routeWhatsapp(isDoor, band) {
    if (isDoor) {
      return {
        group: 'porta',
        reason: 'category',
        vendor: getOrCreateSessionSeller(VENDEDORES_PORTA, 'porta')
      };
    }
    if (band === '0-10') {
      return { group: 'site', reason: 'band_0_10', vendor: null };
    }
    if (band === '10-50') {
      return {
        group: 'geral',
        reason: 'band_10_50',
        vendor: getOrCreateSessionSeller(VENDEDORES_GERAL, 'geral')
      };
    }
    if (band === '>50') {
      return {
        group: 'geral',
        reason: 'band_above_50',
        vendor: getOrCreateSessionSeller(VENDEDORES_ACIMA_50, 'geral')
      };
    }
    return null;
  }

  function buildWaLink(telefone) {
    var msg = 'Ei! Cheguei através do Site.';
    return 'https://wa.me/' + telefone + '?text=' + encodeURIComponent(msg);
  }

  function initWhatsappForm(form) {
    var doorRoot = document.getElementById('macal-lead-popup-root');
    var isDoorHint = doorRoot ? doorRoot.getAttribute('data-door-hint') === 'true' : false;

    preloadCommonFields(form, 'Whatsapp');
    writeUrlFinal(form, 'Whatsapp');

    form.addEventListener('input', function (event) {
      if (event.target && event.target.hasAttribute('data-macal-phone-mask')) {
        maskPhoneNumber(event);
        event.target.setCustomValidity('');
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      // 06/10/2026 (#8): campo anti-robô preenchido = não é pessoa; não envia.
      var honeypot = form.querySelector('[name="aG9uZXlwb3Q"]');
      if (honeypot && (honeypot.value || '').trim()) return;
      if (form.__macalSubmitting) return;

      // Mesmo gate de validação do popup de Ligação (novalidate + required
      // não bloqueiam sozinhos o submit) — ver handoff de 2026-09-22.
      applyPhoneValidity(form);
      if (typeof form.reportValidity === 'function' && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var faixaEl = form.querySelector('#MacalWhatsappFaixaM2');
      var band = faixaEl ? faixaEl.value : '';
      var isDoor = isDoorPage(isDoorHint);

      var route = routeWhatsapp(isDoor, band);
      if (!route) {
        // Faixa de m² ausente/inválida: bloqueia o envio de forma explícita
        // em vez de cair silenciosamente no pool geral (requisito do
        // briefing A513-T33). O atributo `required` do <select> já cobre o
        // caso mais comum (nada selecionado); este é um cinto-e-suspensório.
        if (faixaEl) {
          faixaEl.setAttribute('aria-invalid', 'true');
          faixaEl.focus();
        }
        setStatus(form, 'Selecione a faixa de m² para continuar.', 'error');
        dispatch('whatsapp_lead_error', { popup: 'whatsapp', reason: 'missing_band' });
        return;
      }

      form.__macalSubmitting = true;
      setSubmitting(form, true);
      setStatus(form, 'Enviando...', null);

      var leadCf36 = form.querySelector('#LEADCF36_Whatsapp');
      var returnUrl = form.querySelector('#ReturnURLWhatsapp');

      var destination;
      var target;
      if (route.vendor) {
        leadCf36.value = route.vendor.nome;
        target = buildWaLink(route.vendor.telefone);
        returnUrl.value = target;
        destination = 'vendor';
      } else {
        // Destino "Site" (não-porta, 0-10 m²): padronização do Victor em
        // 2026-10-01 — essa faixa sempre redireciona para a HOME da loja
        // (https://loja.macalmadeiras.com.br/), e não mais para a página
        // atual de onde o popup foi aberto. Decisão registrada em
        // macal-projeto-atlas/02-decisoes/decisao-roteamento-vendedores-whatsapp-loja-site-2026-10-01.md.
        // O envio do lead ao Zoho não muda (returnURL continua sendo
        // preenchido normalmente); só o destino pós-envio muda.
        leadCf36.value = 'Site';
        target = 'https://loja.macalmadeiras.com.br/';
        returnUrl.value = target;
        destination = 'site';
        try {
          sessionStorage.setItem(SITE_ACK_KEY, '1');
        } catch (_e) {
          /* no-op */
        }
      }

      syncClickFields(form);
      writeUrlFinal(form, 'Whatsapp');
      formatPhoneBeforeSubmit(form);

      dispatch('whatsapp_route_selected', {
        popup: 'whatsapp',
        group: route.group,
        band: band,
        vendor: route.vendor ? route.vendor.nome : 'Site'
      });

      dispatch('whatsapp_lead_submit', {
        popup: 'whatsapp',
        lead_source: form.querySelector('input[name="Lead Source"]').value,
        has_door_hint: isDoorHint
      });

      var finalized = false;
      function finalize() {
        if (finalized) return;
        finalized = true;
        // Bug ao vivo confirmado em 2026-10-01 (visitantes reais presos em
        // crm.zoho.com/crm/WebToLeadForm com a mensagem genérica "Obrigado
        // por enviar sua resposta" em vez de ir para o WhatsApp). Causa raiz:
        // o campo returnURL é preenchido corretamente (confirmado em teste
        // ponta a ponta, ver docs/architecture/migracao-leads-zoho-2.0.md),
        // mas o <form> não tinha `target`, então form.submit() navegava a
        // aba inteira para o Zoho e o redirecionamento dependia do Zoho
        // honrar o returnURL dinâmico para um domínio externo (wa.me) — o
        // que não acontece de forma confiável. Mesma causa estrutural já
        // resolvida no popup de Ligação: o form agora envia para um iframe
        // oculto (macalHiddenFrameWhatsapp) e o redirecionamento real é
        // feito aqui via JS, sem depender do returnURL da Zoho.
        try {
          form.submit();
        } catch (_e) {
          dispatch('whatsapp_lead_error', { popup: 'whatsapp', reason: 'form_submit_failed' });
        }
        dispatch('whatsapp_redirect', { popup: 'whatsapp', destination: destination, target: target });

        window.setTimeout(function () {
          window.location.href = target;
        }, 400);
      }

      window.setTimeout(finalize, 400);
    });
  }

  function maybeShowSiteAckToast() {
    var acked;
    try {
      acked = sessionStorage.getItem(SITE_ACK_KEY);
    } catch (_e) {
      acked = null;
    }
    if (!acked) return;
    try {
      sessionStorage.removeItem(SITE_ACK_KEY);
    } catch (_e) {
      /* no-op */
    }
    // Mensagem de confirmação simples, sem depender de navegação nova.
    // Reaproveita o mesmo elemento de status visualmente escondido não é
    // possível pós-reload (o popup já fechou) — usa um alerta acessível
    // temporário anexado ao body.
    var toast = document.createElement('div');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.className = 'macal-lead-popup__toast';
    toast.textContent = 'Recebemos seu contato! Nossa equipe vai retornar em breve.';
    toast.style.position = 'fixed';
    toast.style.insetInlineStart = '50%';
    toast.style.insetBlockEnd = '24px';
    toast.style.transform = 'translateX(-50%)';
    toast.style.background = '#0b2e1a';
    toast.style.color = '#ffffff';
    toast.style.padding = '0.75rem 1.25rem';
    toast.style.borderRadius = '8px';
    toast.style.zIndex = '9999';
    toast.style.maxWidth = '90vw';
    toast.style.textAlign = 'center';
    document.body.appendChild(toast);
    window.setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 6000);
  }

  function openPopup(dialogId, channel) {
    var el = document.getElementById(dialogId);
    if (!el || typeof el.showDialog !== 'function') return;
    el.showDialog();
    dispatch('whatsapp_popup_open', { popup: channel });
  }

  function wireTriggers() {
    var triggers = document.querySelectorAll('[data-macal-lead-trigger]');
    triggers.forEach(function (button) {
      button.addEventListener('click', function () {
        var kind = button.getAttribute('data-macal-lead-trigger');
        if (kind === 'phone') {
          if (!PHONE_POPUP_ENABLED) return;
          dispatch('phone_click', { popup: 'ligacao' });
          openPopup('macal-lead-popup-ligacao', 'ligacao');
        } else if (kind === 'whatsapp') {
          openPopup('macal-lead-popup-whatsapp', 'whatsapp');
        }
      });
    });
  }

  function describeTelOrigin(link) {
    var explicit = link.getAttribute('data-macal-origin');
    if (explicit) return explicit;
    var area = 'pagina';
    if (link.closest('footer')) area = 'rodape';
    else if ((window.location.pathname || '').indexOf('/policies/') === 0) area = 'politica';
    else if (link.closest('header')) area = 'cabecalho';
    else if (link.closest('.shopify-section')) area = 'secao';
    var label = (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    return label ? area + ':' + label : area;
  }

  // Links tel: da página abrem o popup de Ligação em vez de discar direto. Se
  // o popup não estiver disponível, não intercepta (o telefone continua
  // funcionando). A navegação tel: feita pelo próprio popup depois do envio é
  // atribuição de location.href, não clique, então não gera laço.
  function interceptTelLinks() {
    document.addEventListener(
      'click',
      function (event) {
        if (event.defaultPrevented) return;
        if (event.button && event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var link = event.target && event.target.closest ? event.target.closest('a[href^="tel:" i]') : null;
        if (!link) return;
        if (link.closest('#macal-lead-popup-root, #macal-lead-popup-ligacao, #macal-lead-popup-whatsapp')) return;
        if (!PHONE_POPUP_ENABLED) {
          // Sem popup: o link tel: segue (o DNI do CTM pode ter trocado o número); só registra o clique.
          dispatch('phone_click', { popup: 'ligacao', origin: describeTelOrigin(link) });
          return;
        }
        var dialog = document.getElementById('macal-lead-popup-ligacao');
        if (!dialog || typeof dialog.showDialog !== 'function') return;
        event.preventDefault();
        dispatch('phone_click', { popup: 'ligacao', origin: describeTelOrigin(link) });
        openPopup('macal-lead-popup-ligacao', 'ligacao');
      },
      true
    );
  }

  function init() {
    persistAttribution();
    interceptTelLinks();
    wireTriggers();

    var ligacaoForm = document.getElementById('webformLigacaoMacal');
    if (ligacaoForm) initLigacaoForm(ligacaoForm);

    var whatsappForm = document.getElementById('webformWhatsappMacal');
    if (whatsappForm) initWhatsappForm(whatsappForm);

    maybeShowSiteAckToast();
  }

  // Para conferir no Console qual versão está no ar: MacalLeadRouter.version
  window.MacalLeadRouter = { version: ROUTER_VERSION };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();